import CountCell from 'components/CountCell';
import ROUTE_NAMES from 'setup/Routing/routeNames';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function FleetsCountCell({
  rowData: { id, totals },
}: CellProps) {
  return (
    <CountCell
      count={totals?.fleets}
      sectionPath={ROUTE_NAMES.admin.managementAccounts}
      pageParams={{
        oemSegmentIds: [id],
        teamIds: [],
        accountIds: [],
        depotIds: [],
      }}
    />
  );
}
